module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section06_03_american-village-064666826985616040956146d09b60c9.jpg";